import {lazy} from 'react'

const GiftShopArchiveScreen = lazy(
  () =>
    import(/* webpackChunkName: 'ArchiveContent' */ './GiftShopArchiveScreen'),
)

export {GiftShopArchiveScreen}
